module.exports = {
  login:{
    zw:'中文',
    mw:'缅文',
    en:'英文',
    name:'登入名称',
    pws:'密码',
    submit:'登入',
    msg:'清将信息填写完整',
    amount:'฿',
    remember:'记住密码'
  },
  navs:{
    phone:'手机',
    tel:'tel',
    betNum:'需投注量'
  },
  home:{
    maintain:'维护中',
    login:'请先登录',
    await:'敬请期待',
    customer:'改密码找客服',
    account:'账户明细',
    message:'讯息',
    per:'会员信息',
    record:'流水查询',
    paw:"重设密码",
    exit:'登出',
    signIn:'登录',
    more:'MORE',
    hot:'HOT TABLE',
    live:'LIVE GAME',
    game:'彩金',
    new:'NEW GAME',
    slot:'SLOT GAME',
    fish:'FISH GAME',
    rng:'RNG GAME',
    index:'首页',
    app:'APP下载',
    t_1:'日期 / Name',
    t_2:'大奖赢额'


  },
  message:{
    title:'讯息',
    per:'个人讯息',
    system:'公告',
    data:'未选择讯息',
    close:'关闭'
  },
  user:{
    title:'会员信息'
  },
  account:{
    title:'账户明细',
    upper:"上分",
    lower:"下分",
    noData:'当前已经没有数据',
    sn:'订单号',
    abbr:'平台缩写',
    point:'点数',
    rate:'汇率点',
    type:'类型',
    time:'时间',
    homePage:"首页",
    lastPage:"尾页",
    total:'共',
    info:'条信息',
    page:'页',
    beforeAccount:'账变前余额',
    afterAccount:'账变后余额',
    amount:'金额',
  },
  record:{
    title:"投注流水",
    no:'订单号',
    amount:'下注金额',
    profit:'盈利',
    time:'时间',
    status:'状态',
    unsettled:'未结算',
    win:'赢',
    lose:'输',
    sum:'和',
    ping:'平台',
    operate:'操作',
    submit:'查看',
    submitTitle:'流水详情'
  },
  download:{
    title:'APP下载',
    domain:"JY076",
    name:'jy99',
    app:"下载 APP",
    num:'4.9',
    score:'5985份評分',
    edition:'# 1',
    style:'游戏APP',
    new:'最新版本',
    time:'2022-03-04 1.63(4.7MB)',
    security:'更高安全性',
    speed:'开启速度更快!',
    remember:"毋须记忆网址!"
  },
  loginPaw:{
    title:'修改登录密码',
    t_2:'旧密码',
    t_3:'新密码',
    t_4:'确认密码',
    t_5:'请输入旧密码',
    t_6:'请输入新密码',
    t_7:'请再次输入密码',
    t_8:'确认',
    t_9:'修改支付密码',
    t_10:'重置支付密码',
    t_11:'重置登入密码',
    t_12:'设置支付密码',
    t_13:'密码',
    t_14:'请输入密码',
    t_15:'请将信息填写完整',
    t_16:'两次密码不一致',
    t_17:'密码已修改',
    t_18:'密码已设置'
  },
  customer:{
    title:'客服中心',
    tip:'尊敬的用户，如需充值或查询网站相关问题，请点击下方官方客服，我们会有专业的客服团队人员 24小时为您服务',
    copy:'复制',
    qrCode:'二维码',
    close:'关闭'
  },
  messenger:{
    title:"24小时在线",
    copy:'复制账号',
    success:'复制成功',
    err:'复制失败',
  },

  Online:{
    title:'在线客服',
    send:'发送',
    drop:'下拉加载',
    face:'QQ表情',
    tip:'请选择要联系的客服',
    del:'系统已清除历史记录',
    test:'请输入要发送的内容',
  },
  thalIndex:{
    t_1:'登入',
    t_2:'WINNERS',
    t_3:'2D/3D',
    t_4:'历史记录',
    t_5:'2D下注',
    t_6:'3D下注',
    t_7:'2D',
    t_8:'3D',
    t_9:'Section',
    t_10:'UPDATED',
    t_11:'Closing Time',
    t_12:'AM',
    t_13:'PM',
    t_14:'投注',
    t_15:"Internet",
    t_16:'SET:',
    t_17:'VALUE:',
    t_18:'Live',
    t_19:'Modern',
    t_20:'Internet',
    t_21:'请选择场次',
    t_22:"当前没有场次"
  },
  ranking:{
    t_1:'Winners',
  },
  bet2D:{
    t_1:' 投注',
    t_2:'Close Time：',
    t_3:'Luck Number',
    t_4:'快捷选号',
    t_5:'注数：',
    t_6:'总金额：',
    t_7:'投注',
    t_8:'快速选择',
    t_9:'Box',
    t_10:'大',
    t_11:'小',
    t_12:'单',
    t_13:'双',
    t_14:'双双',
    t_15:'双单',
    t_16:'单双',
    t_17:'单单',
    t_18:'相同',
    t_19:'1 whole',
    t_20:'the top',
    t_21:'Later',
    t_22:'Star',
    t_23:'Star R',
    t_24:'Power',
    t_25:'Power R',
    t_26:'20 each'
  },
  bet3D:{
    t_1:' 投注',
    t_2:'号码',
    t_3:"赔率",
    t_4:'删除',
    t_5:'金额',
    t_6:'确认号码',
    t_7:'请填写投注金额',
    t_8:'投注成功',
    t_9:'请填写正确的号码格式，如：000',
    t_10:'该号码当期已投满',
    t_11:'请填写号码的投注金额',
    t_12:'幸运号码为：',
    t_13:'投注失败的号码为：',
    t_14:'原因',
    t_15:'请选择号码'
  },
  recordsBet:{
    t_1:'投注记录',
    t_2:'注数',
    t_3:'NO.',
    t_4:'投注额',
    t_5:'收入',
    t_6:'名称',
    t_7:'20231030233000',
    t_8:'号码',
    t_9:'金额',
    t_10:'返现',
    t_11:'赔率',
    t_12:'日期',
    t_13:'返现',


  },
  playerRankRecord:{
    t_1:'注单详情'
  }


}



// WEBPACK FOOTER //
// ./src/assets/i18n/zh.js